export const GET_DRIVERS_LIST = 'GET_DRIVERS_LIST';
export const GET_DRIVERS_LIST_SUCCESS = 'GET_DRIVERS_LIST_SUCCESS';
export const GET_DRIVERS_LIST_FAIL = 'GET_DRIVERS_LIST_FAIL';

export const GET_SINGLE_DRIVER = 'GET_SINGLE_DRIVER';
export const GET_SINGLE_DRIVER_SUCCESS = 'GET_SINGLE_DRIVER_SUCCESS';
export const GET_SINGLE_DRIVER_FAIL = 'GET_SINGLE_DRIVER_FAIL';

export const GET_CUSTOMERS_LIST_SUCCESS = 'GET_CUSTOMERS_LIST_SUCCESS';
export const GET_CUSTOMERS_LIST_FAIL = 'GET_CUSTOMERS_LIST_FAIL';
export const GET_SINGLE_CUSTOMER_SUCCESS = 'GET_SINGLE_CUSTOMER_SUCCESS';
export const GET_SINGLE_CUSTOMER_FAIL = 'GET_SINGLE_CUSTOMER_FAIL';
export const START_GET_CUSTOMER = 'START_GET_CUSTOMER';


export const ADD_DRIVER_FAILED = 'ADD_DRIVER_FAILED';
export const ADD_CUSTOMER_FAILED = 'ADD_CUSTOMER_FAILED';


export const GET_CUISINE_SUCCESS = 'GET_CUISINE_SUCCESS';
export const GET_CUISINE_FAILED = 'GET_CUISINE_FAILED';


export const GET_FOOD_CATEGORIES_SUCCESS = 'GET_FOOD_CATEGORIES_SUCCESS';
export const GET_FOOD_CATEGORIES_FAILED = 'GET_FOOD_CATEGORIES_FAILED';

export const GET_ZONES_SUCCESS = 'GET_ZONES_SUCCESS';
export const GET_ZONES_FAILED = 'GET_ZONES_FAILED';


export const STATUS_CHANGE_DIALOG_SUCCESS = 'STATUS_CHANGE_DIALOG_SUCCESS';


export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_FAIL = 'AUTH_FAIL';
export const AUTH_SIGNOUT = 'AUTH_SIGNOUT';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';


export const GET_ALERTS_SUCCESS = 'GET_ALERTS_SUCCESS';
export const GET_ALERT_SUCCESS = 'GET_ALERT_SUCCESS';
export const GET_MONITORINGS_SUCCESS = 'GET_MONITORINGS_SUCCESS';
export const GET_ORDERS_SUCCESS = 'GET_ORDERS_SUCCESS';
export const GET_ORDER_SUCCESS = 'GET_ORDER_SUCCESS';
export const GET_RESTAURANTS_SUCCESS = 'GET_RESTAURANTS_SUCCESS';
export const GET_MENU_SUCCESS = 'GET_MENU_SUCCESS';
export const GET_TAGS_SUCCESS = 'GET_TAGS_SUCCESS';
export const GET_LIST_ITEMS_SUCCESS = 'GET_LIST_ITEMS_SUCCESS';
export const GET_ITEMS_SUCCESS = 'GET_ITEMS_SUCCESS';



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js